import { GenericTestRouteState } from './generic-test-state'

export const FamilyTestRouteState = GenericTestRouteState.named(
  'FamilyTestRouteState'
)
